//
// forms/js-mkto-field-visibility.js
//
// - Called on load by js-mkto-form.js: if any visibilty rules are present on any fields (data attrs)
//   then this code is executed.
//
// - Note: Testing this was difficult as the Marketo for builder is so difficult to use/terrible.
//
// - Note: Currently only supports 1-2-1 conditionals - i.e "Display this field
//   if xyz field is equal to (or NOT equal to) 'bla'".
//   Does not currently support something like: "Display this field if xyz field
//   is equal to (or NOT equal to) 'foo' AND zyx field is equal/not equal to 'bla'"
//   I began the code with this in mind so there are some parts that are set up as iterable
//   where it's currently not neccessary.
//
// - Note: I started to extend this further to support fields other than Selects but ran out of time.

import find_ancestor from '../helpers/find-ancestor';

export default function run_field_visibility(el_form) {
  const visibility_fields = Array.from(el_form.querySelectorAll('[data-visibility-controlled-field]'));
  if (visibility_fields.length < 1) return false;
  let controller_fields_obj = {};

  const SUPPORTED_CONTROLLER_FIELD_TYPES = {
    SELECT: {
      cb_func: on_picklist_change,
    },
  };

  function show_or_hide_field(field, show = true) {
    field.style.display = show ? 'block' : 'none';
    const wrapper       = find_ancestor(field, 'js-form-item');
    if (wrapper && wrapper.hasAttribute('data-required')) {
      wrapper.setAttribute('data-required', show);
    }
  }

  function on_picklist_change(control_field, controller_field_obj) {
    const visibility_fields = controller_field_obj.visibility_fields;

    visibility_fields.forEach(field => {
      const match = control_field.value === field.value;

      if (field.operator === 'is') {
        const show = field.rule_type === 'show' ? match : !match;
        show_or_hide_field(field.field, show);
      }
    });
  }

  function init_visibility_field(field) {
    // Initially hide all visibility controlled fields for simplicity,
    // then let the controller field take over
    field.style.display = 'none';

    const controller_fields = field.getAttribute('data-visibility-subjectfield').split(', ');

    const field_obj = {
      field,
      name: field.getAttribute('data-name'),
      operator: field.getAttribute('data-visibility-operator'),
      value: field.getAttribute('data-visibility-values'),
      rule_type: field.getAttribute('data-visibility-ruletype'),
    };

    controller_fields.forEach((field_name) => {
      if (!controller_fields_obj[field_name]) controller_fields_obj[field_name] = {};

      if (!controller_fields_obj[field_name].visibility_fields) {
        controller_fields_obj[field_name].visibility_fields = [field_obj];
      }
      else {
        controller_fields_obj[field_name].visibility_fields.push(field_obj);
      }
    });
  }

  function init_control_field(field_selector) {
    const control_field           = el_form.querySelector(`[name='${field_selector}']`);
    const controller_field_obj    = controller_fields_obj[field_selector];
    const visibility_fields       = controller_field_obj.visibility_fields;
    const visibility_fields_names = visibility_fields.map((field => field.name));

    // Only setting these to aid debugging, to make it clear which fields
    // this field is controlling visiility of, and that it is a visibility controller field
    control_field.setAttribute('data-visibility-controller-field', true);
    control_field.setAttribute('data-visibility-controller-target-fields', visibility_fields_names.join(', '));

    function on_control_field_change() {
      const field_type = control_field.nodeName;

      if (!SUPPORTED_CONTROLLER_FIELD_TYPES[field_type]) {
        console.log('Controller field type not supported.')
        return false;
      }

      SUPPORTED_CONTROLLER_FIELD_TYPES[field_type]['cb_func'](control_field, controller_field_obj);
    }

    control_field.addEventListener('change', on_control_field_change);
  }


  visibility_fields.forEach(init_visibility_field);
  Object.keys(controller_fields_obj).forEach(init_control_field);
}

